import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { useLocationSearch } from '../../helpers/hooks/useLocationSearch';
import RentersInsuranceLayout from '../../layouts/RentersInsuranceLayout';
import ComplianceProvider from './ComplianceProvider';
import { ComplianceApplicationRevalidator } from './components/ComplianceApplicationRevalidator';
import { CompletedComplianceFlowGuard } from './guards/competed-compliance-flow.guard';
import { VerifyPolicyDataGuard } from './guards/verify-policy-data.guard';
import { ComplianceDirectLinkProvider } from './providers/compliance-direct-link.provider';
import { validateCovieDirectLinkParams } from './utils/validate-covie-direct-link-params.util';
import { parseQuery } from 'src/helpers/usePrefillApplication';

const ComplianceProviderContainer = () => {
  const { search } = useLocation();
  const parsedDirectLinkURL = parseQuery(search);
  const isComeFromDirectLink =
    validateCovieDirectLinkParams(parsedDirectLinkURL);

  const navigate = useNavigate();
  const getUrlWithQueryParams = useLocationSearch();

  const handleBackButtonClick = () => {
    navigate(getUrlWithQueryParams(ROUTES.COMPLIANCE_TERMS_PATH));
  };

  return (
    <RentersInsuranceLayout
      headerProps={{
        v2: true,
        backButtonAction: isComeFromDirectLink ? null : handleBackButtonClick,
      }}
      progressBarProps={{ progress: '75%' }}
    >
      <CompletedComplianceFlowGuard>
        <ComplianceDirectLinkProvider>
          <VerifyPolicyDataGuard>
            <ComplianceApplicationRevalidator>
              <ComplianceProvider />
            </ComplianceApplicationRevalidator>
          </VerifyPolicyDataGuard>
        </ComplianceDirectLinkProvider>
      </CompletedComplianceFlowGuard>
    </RentersInsuranceLayout>
  );
};

export default ComplianceProviderContainer;
